export default __webpack_public_path__ + "static/media/new-instagram-logo-white-border-icon-png-large.4fae33bb.png";